module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _c('tbody', {
    staticClass: "roster"
  }, _vm._l((_vm.team.players), function(player) {
    return _c('tr', [_c('td', {
      staticClass: "number",
      class: {
        miss: player.miss_next_game
      }
    }, [_vm._v(_vm._s(player.num))]), _vm._v(" "), _c('td', {
      class: {
        miss: player.miss_next_game
      }
    }, [_vm._v(_vm._s(player.name))]), _vm._v(" "), _c('td', {
      class: {
        miss: player.miss_next_game
      }
    }, [_vm._v(_vm._s(player.ref_roster_line))]), _vm._v(" "), _c('td', {
      class: {
        miss: player.miss_next_game
      }
    }, [_vm._v(_vm._s(player.M))]), _vm._v(" "), _c('td', {
      class: {
        miss: player.miss_next_game
      }
    }, [_vm._v(_vm._s(player.F))]), _vm._v(" "), _c('td', {
      class: {
        miss: player.miss_next_game
      }
    }, [_vm._v(_vm._s(player.Ag))]), _vm._v(" "), _c('td', {
      class: {
        miss: player.miss_next_game
      }
    }, [_vm._v(_vm._s(player.Ar))]), _vm._v(" "), _c('td', {
      class: {
        miss: player.miss_next_game
      }
    }, _vm._l((player.skills), function(skill) {
      return _c('span', [_vm._v("\n                                      " + _vm._s(skill.name) + ",\n                              ")])
    }), 0), _vm._v(" "), _c('td', {
      class: {
        miss: player.miss_next_game
      }
    }, [_vm._l((player.upgrades), function(up) {
      return (player.upgrades.length) ? _c('span', {
        class: _vm.helper.getUpgradeStyle(up)
      }, [_vm._v("\n                                      " + _vm._s(_vm.helper.getUpgradeName(up)) + ",\n                              ")]) : _vm._e()
    }), _vm._v(" "), (player.downgrades) ? _c('span', {
      staticClass: "upgrade down"
    }, [_vm._v("\n                                      " + _vm._s(_vm.helper.getDowngrades(player)) + ",\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((player.customizations), function(cust) {
      return (player.customizations && player.customizations.length) ? _c('div', {
        staticClass: "upgrade stats"
      }, _vm._l((cust.skills), function(skill) {
        return (cust.skills) ? _c('span', [_vm._v(_vm._s(skill.name) + ", ")]) : _vm._e()
      }), 0) : _vm._e()
    })], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(player.total_xp))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "additional_skills",
      class: {
        miss: player.miss_next_game
      }
    }, [_vm._v(_vm._s(player.base_cost + player.evolution_cost) + "k")])]), _vm._v(" "), _c('td', [(_vm.isRevokable(player.id)) ? _c('button', {
      staticClass: "alert small action",
      attrs: {
        "id": player.id
      },
      on: {
        "click": function($event) {
          return _vm.addPlayerToFireList(player.id)
        }
      }
    }, [_vm._m(2, true)]) : _c('button', {
      staticClass: "small action",
      attrs: {
        "id": player.id
      },
      on: {
        "click": function($event) {
          return _vm.removePlayerFromFireList(player.id)
        }
      }
    }, [_vm._m(3, true)])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-12 text-left columns note mb-1"
  }, [_vm._v("\n    NB: cliquez sur la poubelle pour virer un joueur\n  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "roster"
  }, [_c('tr', [_c('th', {
    attrs: {
      "width": "2%"
    }
  }, [_vm._v("N°")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Nom")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Position")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "2%"
    }
  }, [_vm._v("M")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "2%"
    }
  }, [_vm._v("F")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "2%"
    }
  }, [_vm._v("Ag")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "2%"
    }
  }, [_vm._v("Ar")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Compétences")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Evolutions")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Xp")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Prix")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-undo",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-723c459c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/revokes/player-revokes.vue
// module id = 769
// module chunks = 0